import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import PortfolioItemCard from './PortfolioItemCard.tsx';
import PortfolioModalNew from './PortfolioModalNew.tsx';
import PortfolioQuestion from '../../../MainInfoItem/PortfolioItem/PortfolioQuestion';
import PortfolioAnswer from '../../../MainInfoItem/PortfolioItem/PortfolioAnswer';
import { deletePortfolio, getPortfolioQuestions, openMainModal } from '../../../../store/actions';
import { buildNavigationParams } from '../../../../utils/navigationHelpers.ts';

interface PortfolioCardWithLogicProps {
  portfolio: {
    id: string | number;
    name: string;
    description?: string;
    type?: 'producto' | 'servicio';
    price?: string | number;
    priceUnit?: string;
    createdAt?: string;
    portfolio_images?: Array<{ image: string }>;
    zone?: string;
    startDate?: string;
    endDate?: string;
  };
  myPerson: boolean;
  userData: any;
  portfolioQuestions: any;
  deletePortfolio: (id: number) => void;
  getPortfolioQuestions: (id: string | number) => void;
  openMainModal: (config: any) => void;
  currentTab?: string;
}

const PortfolioCardWithLogic: React.FC<PortfolioCardWithLogicProps> = ({
  portfolio,
  myPerson,
  userData,
  portfolioQuestions,
  deletePortfolio,
  getPortfolioQuestions,
  openMainModal,
  currentTab
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPortfolio, setShowPortfolio] = useState(false);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);

  useEffect(() => {
    getPortfolioQuestions(portfolio.id);
  }, [portfolio.id, getPortfolioQuestions]);

  const portfolioQuestionsForItem = portfolioQuestions[portfolio.id] || [];
  const questionsNotAnswered = portfolioQuestionsForItem.filter((question: any) => question?.answers?.length === 0);

  const handleDelete = () => {
    openMainModal({
      title: "Eliminar publicación",
      body: "¿Estás seguro que deseas eliminar esta publicación de tu perfil?",
      iconType: "warning",
      confirmHandler: () => {
        deletePortfolio(parseInt(String(portfolio.id)));
      },
    });
  };

  const handleEdit = () => {
    const isFromProfile = location.pathname.startsWith('/perfil/');
    if (isFromProfile && myPerson && userData && currentTab) {
      const userName = userData.type === 'COMPANY' 
        ? userData.razon_social 
        : `${userData.name} ${userData.last_name}`;
      const params = buildNavigationParams(currentTab as string, String(userData.id), userName);
      navigate(`/productos/edit/${portfolio.id}${params}`);
    } else {
      navigate(`/productos/edit/${portfolio.id}`);
    }
  };

  const handleView = () => {
    setShowPortfolio(true);
  };

  const handleOpenQuestions = () => {
    setShowAnswer(true);
  };

  return (
    <>
      <PortfolioItemCard
        portfolio={portfolio}
        myPerson={myPerson}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onView={handleView}
        onOpenQuestions={handleOpenQuestions}
        questionsNotAnswered={questionsNotAnswered.length}
      />

      {showPortfolio && (
        <PortfolioModalNew
          item={portfolio}
          myPerson={myPerson}
          userData={userData}
          closeModal={() => setShowPortfolio(false)}
          portfolioQuestionsForItem={portfolioQuestionsForItem}
        />
      )}

      {showQuestions && (
        <PortfolioQuestion
          portfolioId={portfolio.id}
          closeModal={() => setShowQuestions(false)}
          userData={userData}
        />
      )}

      {showAnswer && (
        <PortfolioAnswer
          portfolioId={portfolio.id}
          closeModal={() => setShowAnswer(false)}
          portfolioQuestions={questionsNotAnswered}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  portfolioQuestions: state.profile.portfolioQuestions,
});

export default connect(mapStateToProps, {
  deletePortfolio,
  getPortfolioQuestions,
  openMainModal,
})(PortfolioCardWithLogic);

